import { useQuery } from "@tanstack/react-query";
import { api } from "@/lib/api";

export const useReleaseMetadata = () => useQuery({
  queryKey: ["release-metadata"],
  queryFn: async () => {
    const { data } = await api.get("/tos/meta");
    if (!data.version || data.version !== data.app_version) throw new Error("Release metadata is inconsistent.");
    return data;
  },
  staleTime: 30_000,
  refetchInterval: 60_000,
});

export const useReleaseDateLabel = () => {
  const { data } = useReleaseMetadata();
  if (!data) return "Loading release date…";
  if (!data.published_at) return data.publication_status === "pending" ? "Publication not yet recorded" : "Publication date unverified";
  return `Effective ${new Date(data.published_at).toLocaleDateString(undefined, { timeZone: "UTC", year: "numeric", month: "long", day: "numeric" })} UTC`;
};